import React, { useEffect, useState } from "react";
import "./AddChargerModal.css";
import AddAgencyModalLogo from "../../assets/images/addAgencyModalLogo.svg";
import { InputText } from "primereact/inputtext";
import PhoneInput from "react-phone-input-2";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { connect, useSelector } from "react-redux";
import * as yup from "yup";

import "react-phone-input-2/lib/bootstrap.css";
import {
  CHARGER_MANUFACTURERS,
  CHARGER_TECHNOLOGY,
} from "../../constants/constant.data";
import { useFormik } from "formik";
import { CommonDate, CommonDropdown, CommonInputField } from "../common-input";
import { addNewCharger } from "../../services/chargers.service";
import useToast from "../../context/toast.hook";
import { Toast } from "primereact/toast";
import { TwoSection } from "../common-grid";
import { useMediaQuery } from "react-responsive";

const AddChargerModal = ({ toggleModal }) => {
  const isMobile = useMediaQuery({
    query: "(max-width: 800px)",
  });
  const { errorToast, successToast, toastRef } = useToast();
  const { currentUser } = useSelector((state) => state.user);
  const { allAgencies } = useSelector((state) => state.agencies);

  const schema = yup.object().shape({
    agencyId: yup
      .string()
      .test("requiredForAdmin", "Agency is required", function (value) {
        if (currentUser?.role === "admin") {
          return !!value;
        }
        return true;
      }),
    chargerNumberPlate: yup.string().required("Changer No is required"),
    technology: yup.string().required("Technology is required"),

    serviceStartedAt: yup.string().required("Model Year is required"),
    chargerManufacturer: yup
      .string()
      .required("Charger Manufacturer is required"),
    efficiency: yup.string().required("Efficieny is required"),
    apparentPower: yup.string().required("Power Rating  is required"),
    // busLength: yup.string().required("Bus Length is required"),
  });

  const handleSubmit = (value) => {
    const currentDate = new Date(value.serviceStartedAt);
    currentDate.setDate(currentDate.getDate() + 5);
    value.serviceStartedAt = currentDate;
    addNewCharger(value)
      .then((res) => {
        toggleModal();
      })
      .catch((error) => {
        errorToast(error);
      });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      agencyId: "",
      chargerNumberPlate: "",
      technology: "",
      efficiency: "",
      apparentPower: "",
      chargerManufacturer: "",
      serviceStartedAt: "",
      // busLength: "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  return (
    <>
      <Toast ref={toastRef} />
      <div className="modalCharger">
        <div className="modalInternalsCharger">
          <img
            className="logoModal"
            src={AddAgencyModalLogo}
            alt="ModalLogo"
          ></img>
          <br />
          <span className="modalHeading">Add a New Charger</span>
          <br />
          <span className="headingPlaceholder" />
          <div className="inputFieldBoxBusData">
            {currentUser?.role === "admin" && (
              <div className="inputFieldBoxCharger">
                <strong>Select Agency</strong>
                <br />
                <CommonDropdown
                  formik={formik}
                  name="agencyId"
                  optionArray={allAgencies}
                  optionKey="_id"
                  optionLabel="name"
                  placeholder="Select Agency"
                  label="Agency"
                  style={{
                    marginTop: "7px",
                  }}
                />
              </div>
            )}
            <div className="inputFieldBoxCharger">
              <strong>Charger No</strong>
              <br />

              <CommonInputField
                formik={formik}
                style={{
                  width: "100%",
                  marginTop: "7px",
                  backgroundColor: "#F9F9F9",
                }}
                placeholder="BV 2666"
                name="chargerNumberPlate"
              />
            </div>

            <div className="inputFieldBox">
              <label htmlFor="email" className="block text-800">
                <strong>Manufactured by</strong>
              </label>
              <CommonDropdown
                formik={formik}
                name="chargerManufacturer"
                optionArray={CHARGER_MANUFACTURERS}
                optionKey="key"
                optionLabel="label"
                placeholder="Manufactured by"
                label="Manufactured by"
                style={{
                  marginTop: "7px",
                }}
              />
            </div>

            <div className="inputFieldBox">
              <label htmlFor="email" className="block text-800">
                <strong>Model Year</strong>
              </label>

              <CommonDate
                placeholder="Click here to select a year"
                formik={formik}
                style={{
                  marginTop: "7px",
                }}
                name="serviceStartedAt"
                view="year"
                dateFormat="yy"
                isNew
              />
            </div>

            <div className="inputFieldBoxCharger">
              <label htmlFor="email" className="block text-800">
                <strong>Technology</strong>
              </label>

              <CommonDropdown
                formik={formik}
                name="technology"
                optionArray={CHARGER_TECHNOLOGY}
                optionKey="key"
                optionLabel="key"
                placeholder="Select Technology"
                label="Technology"
                style={{
                  marginTop: "7px",
                }}
              />
              <br />
              <br />

              <TwoSection
                firstLabel="Efficiency (%)"
                firstSection={
                  <CommonInputField
                    formik={formik}
                    style={{
                      width: !isMobile ? "243px" : "100%",
                      marginTop: "7px",
                      backgroundColor: "#F9F9F9",
                    }}
                    placeholder="40%"
                    name="efficiency"
                    type="number"
                    max="100"
                    isPercentage
                  />
                }
                secondLabel="Power Rating (kVA)"
                secondSection={
                  <CommonInputField
                    formik={formik}
                    style={{
                      width: !isMobile ? "243px" : "100%",
                      marginTop: "7px",
                      backgroundColor: "#F9F9F9",
                    }}
                    placeholder="100kVA"
                    name="apparentPower"
                    type="number"
                  />
                }
              />

              <div className="addBackBoxCharger">
                <div className="addButton">
                  <Button
                    label="Add"
                    style={{
                      background: "#1C9894",
                      width: "140px",
                      border: "0",
                    }}
                    onClick={formik.handleSubmit}
                  />
                </div>
                <div className="addButton">
                  <Button
                    label="Back"
                    style={{
                      background: "#FFFFFF",
                      width: "140px",
                      color: "#1C9894",
                      marginLeft: "20px",
                      borderColor: "#1C9894",
                    }}
                    onClick={() => {
                      toggleModal(true);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="overlay"
        onClick={() => {
          toggleModal(true);
        }}
      ></div>
    </>
  );
};

export default AddChargerModal;
